import type { IconNode } from '../types';

/**
 * @name scarf
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkuNSAyLjUgNyAxNWMtLjUuNS0uNiAxLjUtLjIgMkw5IDIwIDIxLjYgNy42YTIgMS43IDAgMCAwIC4xLTEuOWwtMi0zYy0uMi0uNC0uNy0uNy0xLjItLjdoLTEzYy0uNSAwLTEgLjMtMS4yLjdsLTIgM2EyIDEuNyAwIDAgMCAuMiAybDYgNS44IiAvPgogIDxwYXRoIGQ9Ik0xMiAxMCA0LjUgMi41IiAvPgogIDxwYXRoIGQ9Ik0xMyAyMHYyIiAvPgogIDxwYXRoIGQ9Ik0xNiA2SDgiIC8+CiAgPHBhdGggZD0iTTE3IDEyLjFWMjIiIC8+CiAgPHBhdGggZD0iTTE3IDE4aDQiIC8+CiAgPHBhdGggZD0iTTE3IDIwSDl2MiIgLz4KICA8cGF0aCBkPSJNMjEgOC4yVjIwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/scarf
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const scarf: IconNode = [
  [
    'path',
    {
      d: 'M19.5 2.5 7 15c-.5.5-.6 1.5-.2 2L9 20 21.6 7.6a2 1.7 0 0 0 .1-1.9l-2-3c-.2-.4-.7-.7-1.2-.7h-13c-.5 0-1 .3-1.2.7l-2 3a2 1.7 0 0 0 .2 2l6 5.8',
      key: 'ke54ui',
    },
  ],
  ['path', { d: 'M12 10 4.5 2.5', key: 'l2kccz' }],
  ['path', { d: 'M13 20v2', key: '1t5i3p' }],
  ['path', { d: 'M16 6H8', key: 'whfohi' }],
  ['path', { d: 'M17 12.1V22', key: '1sn4cd' }],
  ['path', { d: 'M17 18h4', key: 'xlnm2s' }],
  ['path', { d: 'M17 20H9v2', key: '81fvye' }],
  ['path', { d: 'M21 8.2V20', key: 'pnvrlw' }],
];

export default scarf;
